import React from 'react';
import { BiUserCircle } from 'react-icons/bi';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Button, Flex, Icon, Text } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import { analyticsIds } from '../../../../../../../constants/analyticsIds';
import { resendUserInviteEmail, selectAdminPageNewUserData } from '../../../../../../../redux/modules/adminPage';

function InviteUser({ user }) {
  let resendInvite = false;
  const dispatch = useDispatch();
  let currentUser = useSelector(selectAdminPageNewUserData);

  if (user) {
    resendInvite = true;
    currentUser = user;
  }

  return (
    <Box bg="white" borderRadius="10px" height="321px" p={2} textAlign="center" w="100%">
      <Flex direction="column" height="inherit" justifyContent="center" w="inherit">
        <Text textStyle="bodyXl600">Invite Member to Pins</Text>
        <Text fontSize="md" mb={4}>Send an invitation with everything they need to get started</Text>
        <Icon as={BiUserCircle} color="#4ECDC4" height="69px" m="0 auto" w="69px" />
        <Text textStyle="bodyXl600">
          {currentUser.userFirstName}
          {' '}
          {currentUser.userLastName}
        </Text>
        <Text>{ currentUser.userEmail }</Text>
        {
        resendInvite && (
        <Button
          colorScheme="green"
          data-analytics-id={analyticsIds.adminSettingsPage.users.createUserForm.resendInviteButton}
          display="table"
          m="20px auto"
          variant="primary"
          onClick={() => dispatch(resendUserInviteEmail(currentUser.userId))}
        >
          Resend Invite
        </Button>
        )
      }
      </Flex>
    </Box>
  );
}

InviteUser.propTypes = {
  user: PropTypes.shape({
    userId: PropTypes.number,
    userFirstName: PropTypes.string,
    userLastName: PropTypes.string,
    userEmail: PropTypes.string
  })
};

export default InviteUser;
